import PropTypes from "prop-types";
import OptOutFormCMP from "@/components/forms/OptOutForm";

import { Header } from "../Header";

import styles from "./OptOutForm.module.scss";

const OptOutForm = ({ handleBack, currentJob, handleSubmit }) => {
  return (
    <>
      <Header handleBack={handleBack} currentJob={currentJob} />

      <h2 className={styles.subtitle}>
        So we may better identify future opportunities for you, please briefly elaborate why you’re
        not interested in this particular opportunity with a few short sentences.
      </h2>

      <OptOutFormCMP onCancel={handleBack} onSubmitOptOut={handleSubmit} />
    </>
  );
};

OptOutForm.propTypes = {
  handleBack: PropTypes.func,
  currentJob: PropTypes.any,
  handleSubmit: PropTypes.func
};

export { OptOutForm };
